import { render, staticRenderFns } from "./workspaceMenu.vue?vue&type=template&id=60318821"
import script from "./workspaceMenu.vue?vue&type=script&lang=js"
export * from "./workspaceMenu.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports